<template>
  <div class="mobile-wrapper">
    <div
      class="justify-content-center so-register text-center"
      :style="BackgroundColor"
    >
      <div class="big-logo">
        <img :src="Logo" @error="imgHttpError" />
      </div>
      <div class="step-title">
        {{ $t("message.soRegisterLastStepMessage") }}
      </div>
      <div class="step-desc">{{ $t("message.soRegisterLastStepDesc") }}</div>
      <div class="col-md-9 bg-white py-4 form-container text-left">
        <form
          class="pt-2 pb-4 d-flex flex-wrap justify-content-center"
          ref="registerSoUserfrm"
          @submit.prevent="registerSoUser"
        >
          <div class="form-group">
            <label for="Email"
              >{{ $t("message.emailAddress") }}
              <span class="required-logo">*</span></label
            >
            <input
              v-validate="'required|email'"
              id="Email"
              v-model="email"
              name="email"
              type="email"
              class="form-control"
              aria-describedby="emailHelp"
              ref="emailAddress"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("email") | inputNameLocale("email") }}
            </div>
          </div>
          <div class="form-group">
            <label for="ConfirmEmail"
              >{{ $t("message.confirmEmail") }}
              <!-- <span class="required-logo">*</span> -->
              </label>
            <input
              v-validate="'confirmed:emailAddress'"
              id="ConfirmEmail"
              v-model="confirmEmail"
              name="confirmEmail"
              type="text"
              class="form-control"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("confirmEmail") | inputNameLocale("confirmEmail") }}
            </div>
          </div>
          <div class="form-group">
            <label for="First Name"
              >{{ $t("message.firstName") }}
              <span class="required-logo">*</span></label
            >
            <input
              v-validate="'required'"
              id="FirstName"
              v-model="firstName"
              name="firstName"
              type="text"
              class="form-control"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("firstName") | inputNameLocale("firstName") }}
            </div>
          </div>
          <div class="form-group">
            <label for="Last Name">{{ $t("message.lastName") }}</label>
            <input
              v-validate="'min:2'"
              id="LastName"
              v-model="lastName"
              name="lastName"
              type="text"
              class="form-control"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("lastName") | inputNameLocale("lastName") }}
            </div>
          </div>
          <div class="form-group">
            <label for="BirthDate">
              {{ $t("message.birthDate") }}
            </label>
            <date-pick
              id="BirthDate"
              name="birthDate"
              v-model="birthDate"
              :format="'DD/MM/YYYY'"
              :inputAttributes="{
                placeholder: 'DD/MM/YYYY',
                class: ['form-control', bdstatus],
              }"
              @input="isValidDate($event)"
              :parseDate="parseDate"
            ></date-pick>
            <span
              v-if="birthDatestatus == 2"
              class="invalid-feedback"
              style="display: block"
              >{{
                birthDatestatus == 1
                  ? "The Date of Birth field is required"
                  : "The Date of Birth should be DD/MM/YYYY format"
              }}</span
            >
            <div class="invalid-feedback">
              {{ OOErrors.first("birthDate") | inputNameLocale("birthDate") }}
            </div>
          </div>
          <div class="form-group">
            <label for="Gender">{{ $t("message.gender") }}</label>
            <vselect
              :options="genderOptions"
              :searchable="false"
              :clearable="false"
              v-model="gender"
              label="text"
              value="id"
            >
              <template slot="option" slot-scope="option">
                {{ option.text }}
              </template>
              <template slot="selected-option" slot-scope="option">
                {{ option.text }}
              </template>
            </vselect>
          </div>
          <div class="form-group">
            <label for="Mobile">
              {{ $t("message.mobile") }}
              <span class="required-logo">*</span>
            </label>
            <input
              v-validate="{
                required: true,
                min: 8,
                regex: this.getRegex(),
                max: this.getMax(),
              }"
              id="Mobile"
              v-model="mobile"
              name="mobile"
              type="text"
              class="form-control"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("mobile") | inputNameLocale("mobile") }}
            </div>
          </div>
          <div class="form-group">
            <label for="Postcode">{{ $t("message.postcode") }}</label>
            <input
              v-validate="'numeric|min:4|max:4'"
              id="Postcode"
              v-model="postcode"
              name="postcode"
              type="text"
              class="form-control"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("postcode") | inputNameLocale("postcode") }}
            </div>
          </div>
          <div class="form-group" v-if="!isGeneralStore">
            <label for="PreferredStore">{{
              $t("message.preferredStore")
            }}</label>
            <vselect
              :options="preferredStoreOptions"
              :searchable="false"
              :clearable="false"
              v-model="preferredStore"
              label="Name"
              value="ID"
            >
              <template slot="option" slot-scope="option">
                {{ option.Name }}
              </template>
              <template slot="selected-option" slot-scope="option">
                {{ option.Name }}
              </template>
            </vselect>
          </div>

          <div class="form-group mt-4 justify-content-left d-flex">
            <Checkbox :label="''" v-model="agree" :IsRadio="false"></Checkbox>
            <p class="agree-container">
              {{ $t("message.agreeSoRegister") + currentStoreDoc.Name }}
            </p>
          </div>

          <div class="form-group mt-3">
            <button
              :disabled="loading || !agree"
              :style="mobileStyles.btn"
              type="submit"
              class="btn btn-lg btn-block shadow btn-primary d-flex justify-content-center fs-19 fw-600"
            >
              {{ $t("message.joinMembership") }}
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
          </div>

          <div class="w-75 mt-4 justify-content-center">
            <p
              style="font-size:0.6875rem;line-height: 1.4;text-align: center;"
            >
              {{$t('message.byContinuingYouAgreeToOur')}}
              <a href="#" @click.prevent="showModal=true">
                <b>
                  {{$t('message.termsOfUsePrivacyStatement')}}
                </b>
              </a>
            </p>
          </div>
          <div v-show="error" class="w-75 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
        </form>
      </div>
      <div v-if="showmeesage" class="m-6 centered">
        <div
          :class="
            success
              ? 'success shadow-md p-6 pr-10'
              : 'error shadow-md p-6 pr-10'
          "
          style="min-width: 240px"
        >
          <p class="messagetext">
            {{
              success
                ? "User registration was successful"
                : "User registration has error"
            }}
          </p>
        </div>
      </div>

      <div class="logo-powered-by">Powered by</div>
      <div class="abacus-logo"></div>
    </div>
    <progressindicator
      v-if="showProgress"
      style="opacity: 0.4"
    ></progressindicator>
    <termsAndConditionsModal v-if="showModal" @close-modal="closeModal"/>
  </div>
</template>

<script>
import shared from "../../sharedscripts/user/register.js";
import { mapGetters, mapActions } from "vuex";
import { wcconfig } from "../../../wcConfig";
import vselect from "vue-select";
import DatePick from "vue-date-pick";
import progressindicator from "../progressindicator";
import Checkbox from "../shared/checkbox";
import { getStoreByHqID } from "../../api/services/storeService.js";
import termsAndConditionsModal from "../shop/partials/termsAndConditionsModal.vue";

export default {
  components: {
    vselect,
    DatePick,
    progressindicator,
    Checkbox,
    termsAndConditionsModal
  },
  props: {
    storeid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showmeesage: false,
      success: true,
      firstName: "",
      lastName: "",
      email: "",
      confirmEmail: "",
      mobile: "",
      postcode: "",
      birthDate: "",
      loading: false,
      showProgress: false,
      address: "",
      error: "",
      logoUrl: "",
      birthDatestatus: 0,
      genderOptions: [
        { id: 0, text: "Male" },
        { id: 1, text: "Female" },
        { id: 2, text: "Unspecified" },
      ],
      gender: null,
      preferredStoreOptions: [],
      preferredStore: null,
      agree: false,
      showModal: false
    };
  },
  created() {
    this.logoUrl = wcconfig.assets.abacus;
  },
  mounted() {
    const self = this;
    this.showProgress = true;
    this.setStore(this.storeid);
    this.initStore({
      storeId: this.storeid,
      callback: () => {
          self.setStoreLoaded();
      },
    });
  },
  computed: {
    ...mapGetters(["mobileStyles", "viewConfig", "currentStoreDoc"]),
    isGeneralStore() {
      return (
        !this.preferredStoreOptions || this.preferredStoreOptions.length < 2
      );
    },
    bdstatus() {
      return this.birthDatestatus == 2 ? "invaliddatetime" : "";
    },
    Logo() {
      if (
        this.currentStoreDoc &&
        this.currentStoreDoc.ThemeSettings &&
        this.currentStoreDoc.ThemeSettings.BackgroundPhotos
      ) {
        return this.currentStoreDoc.ThemeSettings.BackgroundPhotos.CommonLogo;
      }
      return "";
    },
    BackgroundColor() {
      var styles = [];
      var colour = "#3994ff";
      if (
        this.currentStoreDoc &&
        this.currentStoreDoc.ThemeSettings &&
        this.currentStoreDoc.ThemeSettings.Colours &&
        this.currentStoreDoc.ThemeSettings.Colours.IntroBackground
      ) {
        colour = this.currentStoreDoc.ThemeSettings.Colours.IntroBackground;
      }
      styles.push({ "background-color": `${colour}` });
      return styles;
    },
  },
  methods: {
    ...shared.methods,
    ...mapActions(["initStore"]),
    closeModal() {
      this.showModal = false;
    },
    parseDate(dateString) {
      var date = dateString.split("/");
      if (
        date[0] &&
        date[0].length > 0 &&
        date[1] &&
        date[1].length > 0 &&
        date[2] &&
        date[2].length == 4
      ) {
        return new Date(date[2], date[1] - 1, date[0]);
      } else {
        return undefined;
      }
    },
    imgHttpError(event) {
      if (event && event.target && event.target.style)
        event.target.style.display = "none";
    },
  },
  watch: {
    currentStoreDoc(newStore) {
      if (newStore.HQCompanyID != newStore.ID || newStore.IsHQ) {
        var that = this;
        that.showProgress = true;
        getStoreByHqID(newStore.HQCompanyID)
          .get()
          .then(function (snapshot) {
            that.showProgress = false;
            that.preferredStoreOptions = [];
            snapshot.docs.forEach(function (doc) {
              var item = doc.data();
              if (item.ID != newStore.HQCompanyID)
                that.preferredStoreOptions.push(item);
            });
          })
          .catch(() => {
            that.showProgress = false;
          });
      } else {
        this.showProgress = false;
      }
    },
  },
};
</script>
<style lang="scss">
.vdpComponent {
  display: block;
}
.required-logo {
  color: red;
}
.centered {
  position: fixed;
  top: 13%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.success {
  background-color: #22bb33;
  border-radius: 10px;
  padding: 15px 15px;
}
.error {
  background-color: #bb2124;
  border-radius: 15px;
  padding: 5px 10px;
}
.messagetext {
  margin-bottom: 5px !important;
  color: white;
}
.messagebtn {
  text-align: right;
  margin-bottom: 5px !important;
  color: white;
  cursor: pointer;
}

.oo-module {
  .mobile-wrapper {
    .so-register {
      background: #3994ff 0% 0% no-repeat padding-box;
      opacity: 0.95;
      min-height: 100vh;
      .step-title {
        font-size: 20px;
        font-weight: 600;
        color: #ffffff;
        margin-top: 50px;
        margin-left: auto;
        margin-right: auto;
        width: 242px;
      }

      .step-desc {
        width: 95%;
        font-size: 16px;
        color: #ffffff;
        margin-top: 30px;
        margin-left: auto;
        margin-right: auto;
      }
      .form-container {
        padding: 20px 0;
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        background-color: #ffffff;
        margin-top: 10%;
        margin-bottom: 3%;

        .form-group {
          width: 90%;
          margin-bottom: 0.2rem;
          .checkbox-label {
            left: 0;
          }
          span.checkbox-checkmark {
            left: 0px !important;
          }
          p.agree-container {
            position: relative;
            left: -20px;
            text-align: left;
            font-size: 0.6875rem;
            line-height: 1.4;
            text-align: left;
          }
          label {
            font-size: 0.8rem;
            margin-bottom: 0.1rem;
          }

          .form-control,
          .dropdown-toggle {
            border-radius: 0px;
          }
        }
      }

      .big-logo {
        margin-top: 0;
        padding-top: 10%;
        margin-left: 0;
        max-height: 158px;
        max-width: 159px;
        margin-left: auto;
        margin-right: auto;
        img {
          max-height: 100%;
          max-width: 100%;
        }
      }

      .abacus-logo {
        margin-left: auto;
        margin-right: auto;
        height: 26px;
        width: 100px;
        background: transparent url("./../../assets/abacus-logo-white.png") 0%
          0% no-repeat padding-box;
        opacity: 1;
        background-size: contain;
        padding-bottom: 50px;
      }
      .logo-powered-by {
        margin-left: auto;
        margin-right: auto;
        width: 82px;
        font-size: 10px;
        color: #ffffff;
        margin-top: 50px;
      }
    }
  }
}
</style>